export default __webpack_public_path__ + "static/nhs_bsa-6632c829333f4da4db46c136ca54c7f4.png";